import { H6, Image, P } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";

export const ProfileHeader = () => {
  return (
    <div className="d-flex">
      <div className="d-flex-size-email">
        <Image className="rounded-circle me-3" src={dynamicImage(`user/user.png`)} alt="" />
      </div>
      <div className="flex-grow-1">
        <H6 className="f-w-600">{"MARK JENCO"}</H6>
        <P>{"Markjecno@gmail.com"}</P>
      </div>
    </div>
  );
};
